import { uiText, useUiLanguage } from '@/i18n/interface';

import React from 'react';
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { Trash2 } from 'lucide-react';

interface StudentProfile {
  id: string;
  first_name: string;
  last_name: string;
  email: string;
  phone?: string;
  address?: string;
  belt_level?: string;
  join_date?: string;
}

interface StudentDeleteConfirmationProps {
  selectedStudent: string;
  selectedStudentData?: StudentProfile;
  onDelete: () => Promise<void>;
}

const StudentDeleteConfirmation: React.FC<StudentDeleteConfirmationProps> = ({
  selectedStudent,
  selectedStudentData,
  onDelete
}) => {
  useUiLanguage();
  if (!selectedStudent) return null;

  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <Button variant="destructive" className="bg-red-700 hover:bg-red-800">
          <Trash2 className="h-4 w-4 mr-2" />
          {uiText("Master Delete Student")}</Button>
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="text-red-600">{uiText("⚠️ MASTER DELETE STUDENT")}</AlertDialogTitle>
          <AlertDialogDescription className="text-sm">
            <strong className="text-red-600">{uiText("WARNING: PERMANENT DELETION")}</strong>
            <br /><br />
            {uiText("This will")}{' '}<strong>{uiText("permanently delete")}</strong> {selectedStudentData?.first_name} {selectedStudentData?.last_name} {' '}{uiText("and")}{' '}<strong>{uiText("ALL")}</strong> {' '}{uiText("their data including:")}<br />{uiText("• Profile information")}<br />{uiText("• Medical records")}<br />{uiText("• Emergency contacts")}<br />{uiText("• Training history")}<br />{uiText("• Payment records")}<br />{uiText("• Belt progression")}<br /><br />
            <strong className="text-red-600">{uiText("This action CANNOT be undone and will override all system protections.")}</strong>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>{uiText("Cancel")}</AlertDialogCancel>
          <AlertDialogAction
            onClick={onDelete}
            className="bg-red-700 hover:bg-red-800 text-white font-bold"
          >
            {uiText("🗑️ MASTER DELETE PERMANENTLY")}</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default StudentDeleteConfirmation;
